export default __webpack_public_path__ + "f58d9cdd5c62af62893294e463d68819.svg";